const Warning3D = () => {
  return <img src="images/warning-3d.png" />;
};

export default Warning3D;
